/**
 * Hand the browser a file to save from an already-built URL (usually an
 * object URL for a fetched blob).
 *
 * The anchor is clicked WITHOUT being appended to the document. The shared
 * Guru user-action recorder listens for clicks on `document` and names any
 * `<a>` it reaches by role + accessible name, so an appended helper anchor
 * writes a phantom `link_a` row right after the real control's row
 * (`attachment_download`, `missed_order_csv_download`, ...). A detached
 * anchor never reaches that listener. Browsers follow a detached
 * `<a download>` click (the HTML "cannot navigate" rule exempts `<a>` from
 * the connected requirement; FileSaver.js relies on the same behaviour).
 *
 * Callers own the object URL: create it before, revoke it after.
 */
export function triggerBlobDownload(url: string, filename: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
}
